import { FreeGameModelBehavior, SlotConstantsBehavior } from "@quest/murka-games-behavior-leopard/dist"
import { GameParserModel } from "../Platform/GameParserModel";

export class FreeGameModel extends FreeGameModelBehavior {

    constructor(serverModel: any) {
        super(serverModel)
        this.setAnimationSequence(["stackSymbol", "magicPotionWithPrize", "fsPotSymbolConversion", "showAllFrames", "fgBigWin", "triggeringAnimation", "retriggeringAnimation", "jackpotTopPanelAnim", "doNextSpinInFreeGame"]);

    }

    /**
     * Override to remove bigwin from freegame
     */
    public getIsBigWin(winAmount?: number) {
        return 0;
    }
    /**
     *  to find game has freesspin bigwin or not
     */
    public getIsFgBigWin(winAmount: any) {
        let win = this.getCurrentWinAmt() - (ingenuity.parserModel as GameParserModel).getTotalJackpotWinFG();
        if (winAmount !== undefined) {
            win = winAmount;
        }
        const currBet = this.serverModel.getCurrentTotalBet();
        if (win >= currBet * SlotConstantsBehavior.WINTICKUP_THRESHOLDS[0]) {
            return true;
        }
    }
    public getCurrentWinAmt() {
        return (this.serverModel.getCurrentWin() - (ingenuity.parserModel as GameParserModel).getTotalJackpotWinFG()) || 0;
    }
    public getWinMeterTickUpDurationFg(evt: any) {
        const winAmount = evt ? evt : this.getCurrentWinAmt() - (ingenuity.parserModel as GameParserModel).getTotalJackpotWinFG();
        if (this.getIsTurboModeOn()) {
            return SlotConstantsBehavior.WINTICKUP_FG_4;
        }
        else if (winAmount < this.getTotalBet() * SlotConstantsBehavior.WINTICKUP_THRESHOLDS[0]) {
            return SlotConstantsBehavior.WINTICKUP_FG_1;
        }
    }

    //Need to remove this method from behaviour
    public getUserGameCloseData() {
        //
    }
}

